import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reduxAuth/authSlice";
import settingsReducer from "./reduxSettings/settingSlice";
import appointmentsReducer from "./reduxAppointments/appointmentsSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    settings: settingsReducer,
    appointments: appointmentsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
